import React from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'validate.js';

import SectionViewTracker from 'dpl/common/components/SectionViewTracker';
import Divider from 'dpl/components/BreederProfile/mobile/components/shared/Divider';
import ParentDogsCarousel from 'dpl/components/BreederProfile/mobile/components/about/ParentDogsCarousel';
import LocationAndPickup from 'dpl/components/BreederProfile/mobile/components/shared/LocationAndPickup';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import { breederProfileDogsResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';

export default function BreederProfileLocationAndParentDogsContainer() {
  const { analyticsPageName, breederProfileId } = useSelector(
    ({ server }: any) => server
  );

  const {
    isFetching: isFetchingParentDogs,
    value: {
      data: { dogs: parentDogs }
    }
  } = useResourceQuery(breederProfileDogsResourceDefinition(breederProfileId));

  return (
    <div className="BreederProfileLocationAndParentDogsContainer pv8">
      <div className="container-xxl">
        <SectionViewTracker
          name={analyticsPageName}
          category="breeder-profile-tab-about-location"
          properties={{ breeder_profile_id: breederProfileId }}
        >
          <LocationAndPickup />
        </SectionViewTracker>

        {(isFetchingParentDogs || !isEmpty(parentDogs)) && (
          <Divider containerClassName="mt6 mb4" />
        )}
      </div>
      <ParentDogsCarousel dogs={parentDogs} isLoading={isFetchingParentDogs} />
    </div>
  );
}
